<template>
	<div v-if="listNotFound" class="center-container">
			<h1>Page not found</h1>
			<p>Sorry, but there is no person with that ID in our database. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
			<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
	<list 
		v-else
		v-bind:title="'Friends'" 
		v-bind:readerName="readerName"
		v-bind:readerId="readerId"
		v-bind:readerProfileColour="readerProfileColour"
	>
		<p v-if="readerName == '' || readerName == 'undefined' || readerName == null"></p>
		<p v-else-if="notFriends">You must be friends with {{ readerName }} to see {{ readerPronoun }} friends.</p>
		<p v-else-if="friendList == null">There are no people in this list.</p>
		<h2  v-else v-for="friend in friendList" :key="friend.id" class="friend-list">
			<router-link :to="{path:'/profile/' + friend.id}" :style="{ lineHeight: '40px' }"><router-link :to="{path:'/profile/' + friend.id}" class="profile" v-bind:style="{background: friend.profile_color}">profile</router-link>{{ friend.name }}</router-link>
			<button v-if="friendStatus[friend.id] != 'You'" :id="'add-friend-btn-' + friend.id" v-on:click="friendOperation(friend.id)" :style="{ float: 'right' }" :class="(friendStatus[friend.id] == 'Pending' || friendStatus[friend.id] == 'Remove Friend' || friendStatus[friend.id] == 'Unblock') ? 'selected' : ''">{{ friendStatus[friend.id] }}</button>
		</h2>
	</list>
</template>

<script>
	import List from '../../layout/List.vue'

	export default 
	{
		components: 
		{
			List
		},
		created () 
		{
			document.title = "Bookplate";
		},
		data () 
		{
			return {
				info: "",
				status: "",
				notFound: false,
				notFriend: false
			}
		},
		mounted () 
		{
			try 
			{
				let vue = this;

				fetch('https://api.bookplate.co/profile/' + this.readerId + '/friends',
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status == 404)
					{
						vue.notFound = true;
						return "";
					}
					else if(response.status == 403 || response.status == 401)
					{
						vue.notFriend = true;
					}

					return response.json();
				})
				.then(json => this.info = json)
				.then(function (json) 
				{
					if(vue.notFound)
					{
						document.title = "Page not found | Bookplate";
					}
					else
					{
						document.title = json.name + "'s Friends | Bookplate";
					}
				})

				if(!vue.notFound && vue.$store.getters.userId != "0" && !vue.notFriend)
				{
					fetch('https://api.bookplate.co/reader/profile/' + this.readerId + '/friends',
					{
						credentials: 'include'
					})
					.then(function(response)
					{
						if(response.status == 404)
						{
							return "";
						}
						else if(response.status == 403)
						{
							return "";
						}
						else if(response.status == 401)
						{
							console.log("You must be logged in. (Try refreshing the page)");
							vue.$store.dispatch('saveUserLogged', "0");
							vue.router.replace("/profile/" + vue.$route.params.id + "/friends?=logout");
							return "";
						}
						else if(response.status != 200)
						{
							vue.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co.", "Error loading your data (" + response.status + ")");
							return "";
						}

						return response.json();
					})
					.then(json => this.status = json)
				}
			}
			catch(e)
			{
				this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
			}
		},
		computed: 
		{
			listNotFound: function()
			{
				return this.notFound;
			},
			notFriends: function()
			{
				return this.notFriend;
			},
			readerId: function()
			{
				return this.$route.params.id;
			},
			readerName: function() 
			{
				return this.info.name;
			},
			readerProfileColour: function() 
			{
				return this.info.profile_color;
			},
			readerPronoun: function()
			{
				return this.info.pronoun;
			},
			friendList: function()
			{
				return this.info.friends;
			},
			friendStatus: function()
			{
				return this.status;
			}
		},
		methods:
		{
			friendOperation: function(id)
			{
				switch (id) 
				{
					case "Accept Friend":
					case "Add Friend":
						this.addFriend(id);
						break
					case "Remove Friend":
						this.removeFriend(id);
						break
					case "Pending":
						this.removeFriend(id);
						break
					case "Unblock":
						this.unblockReader(id);
						break
				}

				document.getElementById("add-friend-btn-" + id).blur();
			},
			removeFriend: function(id)
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/remove/" + id, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				this.status[id] = "Add Friend";
			},
			unblockReader: function(id)
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/add/" + id, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				this.status[id] = "Add Friend";
			},
			addFriend: function(id)
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}

				const data = {
					headers: 
					{ 
						"content-type": "application/json; charset=UTF-8",
						"accept": "application/text"
					},
					credentials: 'include',
					method: "POST"
				};

				fetch("https://api.bookplate.co/friend/add/" + id, data)
				.then(res=>console.log(res))
				.catch(error=>console.log(error));

				if(this.status[id] == "Accept Friend")
				{
					this.status[id] = "Remove Friend";
				}
				else
				{
					this.status[id] = "Pending";
				}
			}
		}
	}
</script>